import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import useTranslation from 'translations/hooks/useTranslation'
import Text from './Text';
import { Icon } from '@iconify/react';
import Image from 'next/image';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        height: 280
    },
    text: {
        textAlign: 'center',
        color: '#344450',
        fontSize: 30,
        [theme.breakpoints.down('1100')]: {
            fontSize: 24,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 22,
        },
        [theme.breakpoints.down('400')]: {
            fontSize: 20,
        }
    }
}));

export default function ComingSoon() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={"bg-lightGrey flex flex-col items-center justify-center rounded-button min-h-96 mt-5"}>
            <Text text={`${t("comingSoon")}...`} bold center className='text-oeaMain text-sectionTitle'/>
            <div className='mt-4'>
                <Image alt='coming soon' src={"/comingSoon.svg"} width={50} height={50}/>
            </div>
            {/* <div className='bg-oeaMain p-3 rounded-full mt-4'>
                <Icon icon={"mdi:loudspeaker"} className='text-white text-title '/>
            </div> */}
        </div>
    )
}